export default __webpack_public_path__ + "static/media/APEPS.4c74f25b.png";